import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CountUp, { useCountUp } from "react-countup";

import about_bottom from "../images/about_bottom.svg";
import { useRequest } from "../../hooks/useRequest/useRequest";
import { IMG_URL } from "../../api/imgApi/ImgApi";
import Elips from "../images/elips.svg";
import VisibilitySensor from "react-visibility-sensor";
import "./about.css";

const About = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");

  const [aboutClient, aboutData, aboutStatus, aboutError] = useRequest();

  useEffect(() => {
    aboutClient.post("about", {
      language,
    });
  }, [language]);

  console.log(aboutData);

  return (
    <div className="about" id="about">
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="top-bottom"
        data-aos-duration="700"
      >
        <div className="about_header">
          <h2 className={language === "ru" ? "title active" : "title"}>
            {t("ABOUTUS.TITLEONE")}
          </h2>
          <h4
            className={language === "ru" ? "title_next active" : "title_next"}
          >
            {t("ABOUTUS.TITLETWO")}
          </h4>
        </div>
      </div>

      <div className="about_content">
        <div
          data-aos="fade-right"
          data-aos-anchor-placement="top-bottom"
          data-aos-duration="700"
        >
          <div className="about_left">
            <div className="about2"></div>
            <img
              src={IMG_URL + aboutData?.data?.imageUrl}
              alt="about1"
              className="about1"
            />
          </div>
        </div>

        <div className="about_right">
          <div className="about_texts">
            <div
              data-aos="fade-left"
              data-aos-anchor-placement="top-bottom"
              data-aos-duration="700"
            >
              {aboutData?.data?.info}
            </div>
          </div>
          <div className="statik_content">
            <div
              data-aos="flip-left"
              data-aos-anchor-placement="top-bottom"
              data-aos-duration="800"
            >
              <div className="statix_box">
                <h3>
                  <CountUp
                    end={aboutData?.data?.firstValue}
                    redraw={true}
                    duration={4}
                    className="my_countUp"
                  >
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} style={{ fontSize: "36px" }} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                  +
                  <br />
                  <div className="about_company_text">
                    {aboutData?.data?.first}
                  </div>
                </h3>
                <img src={Elips} alt="elips" />
              </div>
            </div>

            <div
              data-aos="flip-right"
              data-aos-anchor-placement="top-bottom"
              data-aos-duration="800"
            >
              <div className="statix_box">
                <h3>
                  <CountUp
                    redraw={true}
                    end={aboutData?.data?.secondValue}
                    duration={4}
                    className="my_countUp"
                  >
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} style={{ fontSize: "36px" }} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                  +<br />
                  <div className="about_company_text">
                    {aboutData?.data?.second}
                  </div>
                </h3>
                <img src={Elips} alt="elips" />
              </div>
            </div>

            <div
              data-aos="flip-left"
              data-aos-anchor-placement="top-bottom"
              data-aos-duration="800"
            >
              <div className="statix_box">
                <h3>
                  <CountUp
                    redraw={true}
                    end={aboutData?.data?.thirdValue}
                    duration={4}
                    className="my_countUp"
                  >
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} style={{ fontSize: "36px" }} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                  +
                  <br />
                  <div className="about_company_text">
                    {aboutData?.data?.third}
                  </div>
                </h3>
                <img src={Elips} alt="elips" />
              </div>
            </div>

            <div
              data-aos="flip-right"
              data-aos-anchor-placement="top-bottom"
              data-aos-duration="800"
            >
              <div className="statix_box">
                <h3>
                  <CountUp
                    redraw={true}
                    end={aboutData?.data?.fourthValue}
                    duration={4}
                    className="my_countUp"
                  >
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} style={{ fontSize: "36px" }} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                  +
                  <br />
                  <div className="about_company_text">
                    {aboutData?.data?.fourth}
                  </div>
                </h3>
                <img src={Elips} alt="elips" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom_img">
        <img src={about_bottom} alt="about" />
      </div>
    </div>
  );
};

export default About;
